<template>
  <AuthTemplate type="register" :openLogin="openLogin">
    <h1>Регистрация</h1>
    <p class="desc_text">Введите код из СМС</p>
    <div style="margin-bottom: 30px">
      <div class="inputs">
        <input
            :ref="`inp_${idx}`"
            type="text"
            :class="{inputed: inputValues[idx]}"
            maxlength="1"
            v-model="inputValues[idx]"
            v-for="(_, idx) in inputValues"
            :key="idx"
            @keyup="e => inputValidate(e, idx)"
        >
      </div>
      <error-text :text="errors.code" style="margin-bottom: 10px"/>
    </div>
    <button-component v-if="showTimer()" :thin="true">Отправить код повторно ({{ time }})</button-component>
    <button-component v-else @click="resendCode()">Отправить код повторно</button-component>
  </AuthTemplate>
</template>

<script>
import ErrorText from "@/components/ui/text/error-text";
import AuthTemplate from '../../../templates/AuthTemplate'
import ButtonComponent from '../../../components/ui/buttons/button-component'
import {mapGetters, mapMutations} from "vuex";

export default {
  name: 'Register_Confirm',
  components: {ButtonComponent, AuthTemplate, ErrorText},
  props: {
    openLogin: Function
  },
  data: () => ({
    time: null,
    endTimer: null,
    inputValues: ['', '', '', ''],
    errors: {},
  }),
  mounted() {
    this.startTimer();
  },
  methods: {
    ...mapGetters(['getRegisterData']),
    ...mapMutations(['openModal', 'setRegisterData']),

    timer() {
      let timer = setInterval(() => {
        this.time = this.$moment.utc((this.$moment(this.endTimer).diff(this.$moment(), 'seconds')) * 1000).format('m:ss');
        if (this.time === '0:00') clearInterval(timer);
      }, 1000);
    },
    startTimer() {
      this.time = '2:00';
      this.endTimer = this.$moment().add(121, 'seconds');
      this.timer();
    },
    showTimer() {
      return this.time && this.time !== '0:00';
    },

    resendCode() {
      this.$api.auth.register.code(this.getRegisterData().id)
          .then(() => this.startTimer())
          .catch(() => this.startTimer());
    },
    confirmCode(code) {
      this.$api.auth.register.verify(this.getRegisterData().id, {code: code})
          .then(({data}) => {
            this.setRegisterData(data);
            this.openModal('register_password');
          }).catch(({response}) => this.errors = response.data.errors);
    },


    inputValidate(e, idx) {
      this.errors.code = null;
      if (e.code === 'Backspace' && idx > 0) {
        this.$refs[`inp_${--idx}`][0].focus()
      }
      /* else if (isNaN(e.key.trim()) || e.key === ' ') {
        e.preventDefault()
      } */
      else {
        if (idx < 3) {
          setTimeout(() => {
            this.$refs[`inp_${++idx}`][0].focus()
          }, 0)
        }
      }
      const value = this.inputValues.join('')
      if (value.length === 4) {
        this.confirmCode(value);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.inputs {
  display: flex;
  margin: 25px -10px 10px -10px;

  input {
    width: 60px;
    height: 80px;
    margin: 0 10px;
    font-size: 32px;
    line-height: 40px;
    text-align: center;
    color: #383838;
    border: 1px solid #E5E5E5;
    border-radius: 5px;
    font-family: "Montserrat", sans-serif;

    &.inputed {
      border: none;
      background: #DBBFA7;
      border-radius: 5px;
    }
  }
}

h1 {
  margin-bottom: 20px !important;
}

.desc_text {
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  line-height: 1.5;
  text-align: center;
  color: #383838;
}
</style>
